<template>
  <div>

    <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.ref"
            :error-messages="refErrors"
            :label="$t('global.reference')"
            required
            @input="$v.item.ref.$touch()"
            @blur="$v.item.ref.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.type"
            :error-messages="typeErrors"
            :label="$t('global.type')"
            required
            @input="$v.item.type.$touch()"
            @blur="$v.item.type.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
  </div>
  
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'StepFieldForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        ref: null,
        name: null,
        namefr: null,
        type: null,
    };
  },
  computed: {
    isLoading() {
      return (
        false
       );
    },
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    refErrors() {
      const errors = [];
      if (!this.$v.item.ref.$dirty) return errors;
      has(this.violations, 'ref') && errors.push(this.violations.ref);
      !this.$v.item.ref.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.item.type.$dirty) return errors;
      has(this.violations, 'type') && errors.push(this.violations.type);
      !this.$v.item.type.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      ref: {
        required,
      },
      name: {
        required,
      },
      namefr: {
        required,
      },
      type: {
        required,
      },
    }
  },
  watch: {
  }
};
</script>

<style>
</style>





